import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tag } from "@vapor/react-custom";
import Typography from "@vapor/react-extended/ExtendedTypography";
import { Stack, useTheme } from "@vapor/react-material";
import { useTranslation } from "react-i18next";
import type { FulfilmentStatus } from "../../../core/api/use-get-fulfilment-detail/FulfilmentStatus";
import { getFulfilmentColorAndVariantByStatus } from "../../../utils/getColorsByStatus";

interface FulfilmentStatusChipProps {
    plural?: boolean;
    status: FulfilmentStatus;
    numberOfWarnings?: number;
}
export const FulfilmentStatusChip: React.FC<FulfilmentStatusChipProps> = ({
    plural = false,
    status,
    numberOfWarnings,
}): JSX.Element => {
    const { t } = useTranslation();
    const theme = useTheme();

    const customization = getFulfilmentColorAndVariantByStatus(status, theme);

    return (
        <Stack
            alignItems="center"
            direction="row"
            overflow="hidden"
            spacing={1}
            whiteSpace="nowrap"
        >
            <Tag
                label={t(
                    `components.fulfilment_status_chip.status.${
                        plural ? "plural." : ""
                    }${status?.toLowerCase() ?? "not_available"}`,
                )}
                type={customization.vaporColor}
                variant={customization.variant}
            />
            {numberOfWarnings !== undefined && numberOfWarnings > 0 && (
                <>
                    <FontAwesomeIcon
                        color={theme.palette.primary.baseWarningColor}
                        icon={faTriangleExclamation}
                        size="lg"
                    />
                    <Typography
                        color={theme.palette.primary.textTitleColor}
                        overflow="hidden"
                        textOverflow="ellipsis"
                        variant="subtitle"
                    >
                        {`(${numberOfWarnings})`}
                    </Typography>
                </>
            )}
        </Stack>
    );
};
